<template>
  <section class="promo-materials">
    <div
      v-if="sub_affiliate_id"
      class="promo-materials__title-subaffiliate"
    >
      <button
        class="btn btn-outline-primary btn-sm mt-0 mb-0 mr-16"
        @click="handleBack"
      >
        &lt; {{ $t('profile.buttons.back') }}
      </button>
      <span>{{ $t('subAffiliates.card.title') }}</span> /
      <span class="text-green"> {{ sub_affiliate_email }} </span> /
      {{ $t('media.media') }}
    </div>
    <TableCard
      ref="datatable"
      v-model:sort="sorting"
      v-model:page="page"
      v-model:page-size="pageSize"
      class="promo-materials__table ui-m-md-t"
      :loading="loading"
      :columns="columns"
      :sort-by-name="sortByName"
      :sort-dir-name="sortDirName"
      :rows="rows"
      :count="count"
      :formaters="formaters"
      :actions="!isEmptyOffers ? actions : undefined"
      :header="$t('media.media')"
      tablet-layout
      dont-fill-empty
      extend-height
      i18n-path="media"
      @fetch-data="fetchDataTable"
    >
      <!-- vue3-migration -- 2 слота подряд, пихаю в 1 template -->
      <template v-slot:header>
        <TableCardSearchHeader
          v-model="search"
          class="ui-g-md"
          @search="handleSearch"
        />
        <div
          :class="[
            'ui-mobile-12',
            'ui-mobile-wrap',
            'ui-d-flex'
          ]"
        >
          <UiFilters
            :use-filters="availableFilters"
            :filters="filters"
            :route="route"
            @input="getProMaterials"
            @reset="reset"
          />
        </div>
      </template>
    </TableCard>
    <MediaTagsPopup ref="tagsPopup" />
  </section>
</template>

<script>
import UrlMixin from '@/components/Query/url-mixin';
import UrlMixinHooks from '@/components/Query/url-mixin-hooks';
import { pageSizeMixin, resolvePageSize } from '@/views/Dashboard/Reports/page_size';
import TableCard from '@/components/Cards/TableCard.vue';
import TableCardSearchHeader from '@/components/Cards/TableCardSearchHeader.vue';
import tableFlowMixinGenerator from '@/views/Dashboard/Reports/tableFlowMixin';
import UiFilters from '@/components/UiFilters/UiFilters.vue';
import InjectPlugins from '@/components/Report/Components/inject-plugins';
import UiTableAction from '@/components/ui/UiTableAction.vue';
import MediaTagsPopup from './Media/MediaTagsPopup.vue';
import Formatters from './CustomReports/formaters';

const sizes = {
  1080: 20,
  1440: 30,
};
const viewName = '/promo-materials';
const pageLimitProp = 'limit';
const pageSize = resolvePageSize(viewName, {
  _default: 15,
  sizes,
});

const defaultSettings = {
  search: '',
  language_code: 'all',
  site_id: 'all',
  type: 'all',
  visibility: 'all',
  sort_column: 'updated_at',
  sort_dir: 'desc',
  page: 1,
  pageSize,
  sub_affiliate_id: '',
  sub_affiliate_email: '',
};

const fetch = async (ctx, params) => {
  if (ctx.$_.isEmpty(params)) {
    params = {
      ...defaultSettings,
    };
  }

  const itemsParams = {
    search: params.search || defaultSettings.search,
    language_code: params.language_code && params.language_code !== 'all' ? params.language_code : '',
    site_id: params.site_id && params.site_id !== 'all' ? params.site_id : '',
    type: params.type && params.type !== 'all' ? params.type : '',
    limit: params.limit || pageSize || defaultSettings.limit,
    offset: params.offset || defaultSettings.offset,
    sort_column: params.sort_column || defaultSettings.sort_column,
    sort_dir: params.sort_dir || defaultSettings.sort_dir,
    sub_affiliate_id: params.sub_affiliate_id,
  };

  const visibilityStatus = params.visibility && params.visibility !== 'all' ? params.visibility : '';
  if (visibilityStatus !== '') {
    itemsParams.visibility = visibilityStatus;
  }

  return await ctx.$store.dispatch('getItems', itemsParams);
};

const tableFlowMixin = tableFlowMixinGenerator({
  defaultParams: {
    ...defaultSettings,
  },
  params: Object.keys(defaultSettings),
  fetch,
  fetchOnActivated: false,
  windowRefreshHook: true,
  sortByName: 'sort_column',
  sortDirName: 'sort_dir',
});

export default {
  // name: 'Media',
  name: 'PromoMaterials',
  fetch,
  data() {
    return {
      route: 'promoMaterials',
      sub_affiliate_id: '',
      sub_affiliate_email: '',
      lastQuery: {},
      filters: this.getDefaultFilter(),
      availableFilters: [
        'language', 'brand', 'type', 'visibility',
      ],
      viewName,
      pageLimitProp,
      columns: [
        {
          name: 'incrementing_id',
          align: 'left',
          filterable: false,
          sortable: 'custom',
          width: 60,
        },
        {
          name: 'media_type',
          align: 'left',
          filterable: true,
          sortable: false,
          width: 120,
          renderValue: (v) => `<span class="!tw-flex">
                                <span class="">${this.$t(`media.${v.text}`)}</span>
                                ${v.icons.length ? `${v.icons.map((e) => `<i class="far fa-${e} ml-4 mt-2"></i>`).join('')}` : ''}
                              </span>`,
        },
        {
          name: 'name',
          align: 'left',
          filterable: true,
          sortable: 'custom',
          width: 250,
        },
        {
          name: 'language_codes',
          align: 'left',
          filterable: true,
          sortable: false,
          renderValue: (v) => (v.length ? v.join(', ') : '—'),
        },
        {
          name: 'visible_brands',
          align: 'left',
          filterable: true,
          sortable: false,
          renderValue: (v) => (v.length ? v.map((e) => e.site_name).join(', ') : '—'),
        },
        {
          name: 'sizes',
          align: 'left',
          filterable: true,
          sortable: false,
          width: 300,
          renderValue: (v) => (v.length ? v.join(', ') : '—'),
        },
        {
          name: 'visibility',
          align: 'left',
          filterable: true,
          sortable: false,
          width: 140,
          renderValue: Formatters.visibility.bind(this),
        },
        {
          name: 'updated_at',
          align: 'left',
          filterable: true,
          sortable: 'custom',
          width: 150,
          format: 'date-time',
          renderValue: (v) => this.$moment(v).format('DD MMM YYYY'),
        },
        {
          name: 'created_at',
          align: 'left',
          filterable: true,
          sortable: 'custom',
          width: 150,
          format: 'date-time',
          renderValue: (v) => this.$moment(v).format('DD MMM YYYY'),
        },
      ],

      loading: false,
      formaters: Formatters,
    };
  },
  components: {
    MediaTagsPopup,
    TableCard,
    TableCardSearchHeader,
    UiFilters,
  },
  mixins: [
    UrlMixin,
    UrlMixinHooks,
    InjectPlugins,
    pageSizeMixin,
    tableFlowMixin,
  ],
  props: ['passedParams'],
  watch: {
    async $route(to, from) {
      if (to.name !== from.name && to.name === 'routes.promoMaterials' && !to.params.subAffiliateActive) {
        this.sub_affiliate_email = '';
        this.sub_affiliate_id = '';
        this.cacheQuery();
      } else if (to.name === 'routes.promoMaterials') {
        const fromSubAffiliateId = this.decompressUrlQuery(from.params.urlQuery)?.sub_affiliate_id;
        const toSubAffiliateId = this.decompressUrlQuery(to.params.urlQuery)?.sub_affiliate_id;

        if (fromSubAffiliateId !== toSubAffiliateId) {
          this.setFromQuery(this.urlQuery);
          await this.$store.dispatch('getMarketingCampaigns', { sub_affiliate_id: this.sub_affiliate_id });
          await this.$store.dispatch('getPromocodeOffers', { sub_affiliate_id: this.sub_affiliate_id });
          await this.update(this.urlQuery);
        }
      }
    },
    filters: {
      immediate: true,
      handler(value) {
        let _value = value;
        if (!value) {
          this.filter = this.getDefaultFilter();
          _value = this.filter;
        }

        this.language_code = _value.language_code;
        this.site_id = _value.site_id;
        this.type = _value.type;
        this.visibility = _value.visibility;
      },
    },
  },
  computed: {
    isEmptyOffers() {
      return this.$_.isEmpty(this.$store.state.promocode.offers);
    },

    rows() {
      return this.$store.state.media.items.map((i) => ({
        ...i,
        media_type: {
          text: i.type,
          icons: i.supported_platforms,
        },
      }));
    },
    count() {
      return this.$store.state.media.count;
    },

    actions() {
      return {
        width: 80,
        name: () => this.$t('profile.apiKeys.table.actions'),
        operations: [
          {
            name: 'download',
            componentAlt: {
              component: UiTableAction,
              props: (row) => {
                return {
                  tooltipContent: this.$t('profile.apiKeys.createDialog.download'),
                  iconClass: 'far fa-download',
                  colorPreset: 'info',
                  link: row.download_url,
                  linkTarget: '_blank',
                  disabled: row.type !== 'simple_banner' || !row.download_url,
                };
              },
            },
          },
          {
            name: 'get-links',
            componentAlt: {
              component: UiTableAction,
              props: (row) => {
                return {
                  tooltipContent: this.$t('media.get_links'),
                  iconClass: 'far fa-code',
                  colorPreset: 'green',
                  onClick: () => {
                    this.getLinks(row);
                  },
                };
              },
            },
          },
        ],
      };
    },
  },
  methods: {
    handleBack() {
      this.sub_affiliate_email = '';
      this.sub_affiliate_id = '';

      this.lastQuery = {};
      this.$router.push({
        name: 'routes.subAffiliates',
        params: {},
      });
    },
    setFromQuery(query) {
      const { sub_affiliate_id, sub_affiliate_email } = query;

      this.sub_affiliate_id = sub_affiliate_id;
      this.sub_affiliate_email = sub_affiliate_email;
    },
    getDefaultFilter() {
      return {
        language_code: defaultSettings.language_code,
        site_id: defaultSettings.site_id,
        type: defaultSettings.type,
        visibility: defaultSettings.visibility,
      };
    },

    getLinks(row) {
      this.$refs.tagsPopup.open({
        ...row,
        sub_affiliate_id: this.sub_affiliate_id,
      });
    },

    async getProMaterials(data) {
      this.filters = { ...this.filters, ...data };
      this.page = 1;
      await this.update(this.filters);
    },
    reset() {
      this.filters = null;
      this.update(this.filters);
    },
    initFilter(query) {
      const filters = this.$_.pick(query, ['language_code', 'site_id', 'type', 'visibility']);
      const defaultFilters = this.$_.pick(defaultSettings, ['language_code', 'site_id', 'type', 'visibility']);

      this.filters = {
        ...defaultFilters,
        ...this.filters,
        ...filters,
      };
    },

    async update(params = {}) {
      const q = {
        ...this.offsetParams,
        search: this.search,
        ...this.filters,
        ...this.sorting,
        ...params,
      };
      await this.fetchData(q);

      this.search = q.search;
    },
  },
  created() {
    this.setFromQuery(this.passedParams);
    this.$store.dispatch('getMarketingCampaigns', { sub_affiliate_id: this.sub_affiliate_id });
    this.initFilter(this.urlQuery);
    this.update({
      ...this.filters,
      sub_affiliate_id: this.sub_affiliate_id,
    });
    this.actions.operations.forEach((o) => o.component && (o.component = o.component.bind(this)));
  },
  mounted() {
    this.$store.dispatch('getPromocodeOffers', { sub_affiliate_id: this.sub_affiliate_id });
  },
};
</script>

<style lang="scss">
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/media/media';

.promo-materials {
  &__title-subaffiliate {
    font-size: 16px;
    font-weight: 500;
    padding: 8px 24px;
    background: #fff;
  }

  &__status-selector {
    width: 150px;
    // margin-top: 3px;

    // .select2-selection__arrow {
    //   top: 4px !important;
    // }
  }

  &__header-radio-group {
    display: flex;
    // width: unset !important;
    // flex-grow: 0;
  }

  &__header-radio-group-item {
    &.el-radio {
      margin-bottom: 0;
      margin-right: 16px;
    }

    &.el-radio + .el-radio {
      margin-left: 0;
    }

    .el-radio__label {
      padding-left: 4px;
    }
  }

  //.table-card-search-header {
  //  width: 200px;
  //}

  &__table {
    .table-card__header {

      .table-card__header-left {
        flex-grow: 0;
        flex-shrink: 1;
      }

      .table-card__header-right {
        flex-grow: 1;
        width: 100% !important;
      }

      @media (min-width: 1050px) and (max-width: 1455px) {
        .ui-tablet-6 {
          flex-grow: 0.5;
          width: 50% !important;
        }

        .table-card__header-left {
          flex-grow: 1;
        }

        .radio-group__left {
          justify-content: flex-end;
        }

        .ui-tablet-12 {
          flex-grow: 1;
          width: 100% !important;
        }

        .ui-tablet-wrap {
          flex-wrap: wrap !important;
        }
      }

      @media (max-width: 1455px) {
        .table-card__header-title {
          width: unset !important;
          flex-grow: 0;
        }

        .table-card__header-left {
          flex-grow: 1;
          width: 100% !important;
        }

        .table-card__header-right {
          flex-grow: 0;
          flex-shrink: 1;
          width: min-content !important;
        }
      }

      @media (max-width: 650px) {
        .table-card__header-right {
          width: 100% !important;
          flex-grow: 1;
        }
      }
    }
  }
}
</style>
